// src/stores/settings/cache.store.js
import { defineStore } from "pinia";
import { ref } from "vue";
import CacheService from "@/services/settings/cache.service";
import { toast } from "@/utils/toast";

export const useCacheStore = defineStore("cacheSettings", () => {
  const loading = ref(false);

  async function clearCache() {
    loading.value = true;
    try {
      const res = await CacheService.clear();
      toast(res.data?.message || "Cache cleared", "success");
    } catch (e) {
      toast(e?.response?.data?.message || "Failed to clear cache", "error");
      throw e;
    } finally {
      loading.value = false;
    }
  }

  return { loading, clearCache };
});
